/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationType {
    PerPassenger = 'PerPassenger',
    PerBooking = 'PerBooking'
}

export function ApplicationTypeFromJSON(json: any): ApplicationType {
    return ApplicationTypeFromJSONTyped(json, false);
}

export function ApplicationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationType {
    return json as ApplicationType;
}

export function ApplicationTypeToJSON(value?: ApplicationType | null): any {
    return value as any;
}

